<template>
    <div class="receive-discuss">
        <div class="discuss-list">
            <p v-show="isSearchResult">你还没有收到任何评论</p>
            <vue-loading v-show="isshowloading" style="height: calc(100% - 20px);border:none;top:0;left:0"></vue-loading>
            <div class="list-item" v-for="(item, index) in discussDataList" :key="index" v-show="!isSearchResult && !isshowloading">
                <div class="item-left">
                    <img :src="item.avatar">
                </div>
                <div class="item-right">
                    <div class="item-name">{{item.nickname}}</div>
                    <p v-html="item.content"></p>
                    <div class="item-mix">
                        <div class="mix-left">
                            <span style="margin">{{item.ctime}}</span>
                            <span class="item-report" @click="commentReport(item.pid, item.cid, item.userid)">举报</span>
                        </div>
                        <div class="mix-right">
                            <span class="item-like" @click="commentLikes(item.pid, item.cid, item)">赞同({{item.likes}})</span>
                            <span>|</span>
                            <span @click="isShowInputDiscuss(index)">{{clickIndex !== index ? '回复' : '收起回复'}}</span>
                        </div>
                    </div>
                </div>
                <div class="input-discuss" v-show="clickIndex === index && isshowinputdiscuss">
                    <textarea v-model="inputDiscuss" @keyup="changeInput"></textarea>
                    <button @click="submitDiscuss(item.pid, item.userid, item.cid, item)" :class="isdiscusscontent ? 'active' : ''">回复</button>
                </div>
            </div>
        </div>
        <div class="pagination-heart">
            <vue-pagination
                class="square-page"
                :page-size="pageSize"
                :total="total"
                @current-change="goPage">
            </vue-pagination>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: 'receive-discuss',
        mounted () {
            this.updateList()
        },
        computed: {
            receiveDiscussData () {
                return this.$store.getters['myStrategy/receiveDiscussData']
            },
            discussDataList () {
                return this.receiveDiscussData.list
            },
            total () {
                return this.receiveDiscussData.total
            }
        },
        data () {
            return {
                isSearchResult: false,
                currentPage: 1,
                pageSize: 10,
                inputDiscuss: '',
                isdiscusscontent: false,
                isshowloading: false,
                isshowinputdiscuss: false,
                clickIndex: -1
            }
        },
        methods: {
            commentLikes (pid, cid, item) {
                var self = this
                axios.get('/sns/commentlikes', {params: {
                    pid: pid,
                    cid: cid
                }}).then((res) => {
                    if (res.data.errorcode) {
                        self.$tip({
                            message: res.data.errormsg ? res.data.errormsg.toString() : '网络异常',
                            duration: 2000,
                            type: 'danger'
                        })
                    } else {
                        self.$tip({
                            message: '点赞成功',
                            duration: 2000,
                            type: 'success'
                        })
                        item.likes += 1
                    }
                }).catch((error) => {
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    })
                })
            },
            commentReport (pid, cid, userid) {
                var self = this
                axios.get('/sns/commentreport', {params: {
                    pid: pid,
                    userid: userid,
                    cid: cid
                }}).then((res) => {
                    if (!res.data.errorcode) {
                        self.$tip({
                            message: res.data.errormsg ? res.data.errormsg.toString() : '举报成功，后台审核中',
                            duration: 2000,
                            type: 'success'
                        })
                    } else {
                        self.$tip({
                            message: '举报失败，请稍后再试',
                            duration: 2000,
                            type: 'error'
                        })
                    }
                }).catch((error) => {
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    })
                })
            },
            changeInput () {
                if (!this.inputDiscuss) {
                    this.isdiscusscontent = false
                } else {
                    this.isdiscusscontent = true
                }
            },
            isShowInputDiscuss (index) {
                if (this.clickIndex === index) {
                    this.clickIndex = -1
                } else {
                    this.clickIndex = index
                    this.inputDiscuss = ''
                    this.isshowinputdiscuss = true
                }
            },
            goPage (page) {
                this.currentPage = page
            },
            submitDiscuss (pid, userid, cid, item) {
                var self = this
                if (!this.inputDiscuss) {
                    self.$tip({
                        message: '回复内容不能为空',
                        duration: 2000,
                        type: 'danger'
                    })
                } else {
                    axios.post('/sns/addcomment', {
                        pid: pid,
                        receiver_id: userid,
                        rid: cid,
                        content: this.inputDiscuss
                    }).then((res) => {
                        if (res.data.errorcode) {
                            self.$tip({
                                message: '回复失败，请稍后再试',
                                duration: 2000,
                                type: 'error'
                            })
                        } else {
                            self.$tip({
                                message: '回复内容正在后台审核中',
                                duration: 2000,
                                type: 'success'
                            })
                            self.isshowinputdiscuss = false
                            self.$store.dispatch('myStrategy/requestSendDiscuss')
                        }
                    }).catch((error) => {
                        self.$tip({
                            message: error ? error.message : '网络异常',
                            duration: 2000,
                            type: 'error'
                        })
                    })
                }
            },
            updateList () {
                var self = this
                this.isshowloading = true
                this.$store.dispatch('myStrategy/requestReceiveDiscuss', {
                    page: this.currentPage,
                    pagesize: this.pageSize
                }).then((result) => {
                    self.isshowloading = false
                    if (self.discussDataList.length === 0) {
                        self.isSearchResult = true
                    } else {
                        self.isSearchResult = false
                    }
                }).catch((error) => {
                    self.isshowloading = false
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    })
                })
            }
        },
        watch: {
            currentPage () {
                this.updateList()
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/mystrategy/receive-discuss.scss';
</style>



// WEBPACK FOOTER //
// src/components/mystrategy/receive-discuss.vue